// What a 422 sends to Sentry: which call it was, and which fields Logyx core
// refused, never what the request or the answer carried. Their bodies hold
// end customers' names and addresses, and a refused password change the
// passwords. Logyx core's answer lists its refusals as "field name: message"
// strings; its own Sentry event for the 422 names the fields too, and shares
// this event's trace.

interface IRequestConfig {
  url?: string;
  method?: string;
}

export const validationCaptureContext = (
  config: IRequestConfig | undefined,
  answer: unknown
) => {
  const errors = (answer as { errors?: unknown } | undefined)?.errors;
  const fields = Array.isArray(errors)
    ? errors
        .filter((error): error is string => typeof error === 'string')
        .map((error) => error.split(':')[0].trim())
    : [];
  return {
    tags: {
      endpoint: (config?.url ?? '').split('?')[0],
      method: config?.method,
    },
    extra: { fields },
  };
};
